var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { addInstrumentationHandler, htmlTreeAsString } from './utils';
import Config from '../../global-config';
import { LogType } from '../../interface';
import { shouldIgnoreOnError } from './helpers';
// 各种上报用到的接口地址，在请求上报的时候可以忽略
var ignoreRequestUrl = [
    new RegExp(/(support-json|support_json).*\/json/),
    // 通过xhr请求的静态资源
    new RegExp(/\.aac|\.flac|\.mov|\.ogg|\.webm|\.wav|\.mp3|\.mp4|\.svga/),
    new RegExp(/front\-perf.*\.com\/api\/call/),
    // tiki json上报接口
    'bflow.tiki.video/json',
    'dotting.cube.tv/live/statistics/report'
];
export var isDisableRequestUrl = function (url) {
    var requestDisableFilter = Config.get('requestDisableFilter');
    // 命中ignoreList
    var flag1 = requestDisableFilter &&
        typeof requestDisableFilter === 'function' &&
        requestDisableFilter(url);
    var flag2 = ignoreRequestUrl.some(function (rule) {
        if (typeof rule === 'string') {
            return url.includes(rule);
        }
        else {
            return rule.test(url);
        }
    });
    return flag1 || flag2;
};
// 添加requestid专用
export var handleDisableRequestid = function (url) {
    if (Config.get('isDisableRequestid'))
        return true;
    var requestDisableFilter = Config.get('requestDisableFilter');
    // 命中ignoreList
    var flag1 = requestDisableFilter &&
        typeof requestDisableFilter === 'function' &&
        requestDisableFilter(url);
    var newIgnoreRequestUrl = __spreadArrays(ignoreRequestUrl, [
        'static-web.bigolive.tv/as/common-static/pear',
        'static-web.likeevideo.com/as/common-static/pear'
    ]);
    var flag2 = newIgnoreRequestUrl.some(function (rule) {
        if (typeof rule === 'string') {
            return url.includes(rule);
        }
        else {
            return rule.test(url);
        }
    });
    return flag1 || flag2;
};
/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        this._onErrorHandlerInstalled = false;
        this._options = options || {
            logHandler: function () { },
            errorHandler: function () { }
        };
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        var _this = this;
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            if (this._onErrorHandlerInstalled) {
                return;
            }
            addInstrumentationHandler({
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                callback: function (data) {
                    // const { msg, url, line, column, error } = data;
                    var error = data.error;
                    if (shouldIgnoreOnError() ||
                        (error && error.__logger_own_request__)) {
                        return;
                    }
                    _this._errorHandler(data);
                },
                type: 'error'
            });
            this._onErrorHandlerInstalled = true;
        }
        if (this._options.onunhandledrejection) {
            addInstrumentationHandler({
                callback: function (e) {
                    var error = e;
                    // dig the object of the rejection out of known event types
                    try {
                        // PromiseRejectionEvents store the object of the rejection under 'reason'
                        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                        if ('reason' in e) {
                            error = e.reason;
                        }
                        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
                        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
                        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
                        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
                        // https://github.com/getsentry/sentry-javascript/issues/2380
                        else if ('detail' in e && 'reason' in e.detail) {
                            error = e.detail.reason;
                        }
                    }
                    catch (_oO) {
                        // no-empty
                    }
                    if (shouldIgnoreOnError() ||
                        (error && error.__logger_own_request__)) {
                        return true;
                    }
                    _this._unhandledrejectionHandler(error);
                },
                type: 'unhandledrejection'
            });
        }
        if (this._options.onxhr) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._xhrHandler(args[0]);
                },
                type: 'xhr'
            });
        }
        if (this._options.onfetch) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._fetchHandler(args[0]);
                },
                type: 'fetch'
            });
        }
        if (this._options.ondom) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._domHandler(args[0], _this._options.ondom);
                },
                type: 'dom'
            });
        }
        if (this._options.onhistory) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._historyHandler(args[0]);
                },
                type: 'history'
            });
        }
        if (this._options.onconsole) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._consoleHandler(args[0]);
                },
                type: 'console'
            });
        }
        if (this._options.onnativeapi) {
            if (window.nativeApi && window.nativeApi.hook) {
                window.nativeApi.hook.on('postMessageByNative', function (data) {
                    return _this._nativeapiHandler.call(_this, __assign(__assign({}, data), { hookType: 'postMessageByNative' }));
                });
                window.nativeApi.hook.on('postMessageToNative', function (data) {
                    return _this._nativeapiHandler.call(_this, __assign(__assign({}, data), { hookType: 'postMessageToNative' }));
                });
            }
        }
    };
    GlobalHandlers.prototype._xhrHandler = function (data) {
        if (Config.get('stop'))
            return;
        // We only capture complete fetch requests
        if (!data.endTimestamp) {
            return;
        }
        if (isDisableRequestUrl(data.xhr.__bigo_log_xhr__.url))
            return;
        var endTimestamp = data.endTimestamp, startTimestamp = data.startTimestamp, xhr = data.xhr;
        var params = {
            endTimestamp: endTimestamp,
            startTimestamp: startTimestamp,
            __bigo_log_xhr__: xhr.__bigo_log_xhr__
        };
        // 仅responseSaveFilter命中的接口才保存response
        var responseSaveFilter = Config.get('responseSaveFilter');
        // 命中ignoreList
        if (responseSaveFilter &&
            typeof responseSaveFilter === 'function' &&
            responseSaveFilter(data.xhr.__bigo_log_xhr__.url)) {
            params.response = xhr.response;
        }
        this._options.logHandler(params, LogType.XHR);
    };
    GlobalHandlers.prototype._fetchHandler = function (data) {
        if (Config.get('stop'))
            return;
        // We only capture complete fetch requests
        if (!data.endTimestamp) {
            return;
        }
        if (isDisableRequestUrl(data.fetchData.url))
            return;
        if (data.error) {
            this._options.logHandler({
                data: data.fetchData,
                error: data.error,
                input: data.args
            }, LogType.FETCH);
        }
        else {
            this._options.logHandler({
                data: data.fetchData,
                status_code: data.response.status,
                startTimestamp: data.startTimestamp,
                endTimestamp: data.endTimestamp
                // 暂时没找到同步获取的body
                // responseBody: res,
            }, LogType.FETCH);
        }
    };
    GlobalHandlers.prototype._domHandler = function (handlerData, dom) {
        if (Config.get('stop'))
            return;
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? htmlTreeAsString(handlerData.event.target, keyAttrs)
                : htmlTreeAsString(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        this._options.logHandler("target: " + target + ", category: " + handlerData.name + ", ", LogType.DOM);
    };
    GlobalHandlers.prototype._historyHandler = function (data) {
        if (Config.get('stop'))
            return;
        this._options.logHandler(data.from + " -> " + data.to, LogType.HISTORY);
    };
    // private _hashchangeHandler(data: { [key: string]: any }): void {
    //   if (Config.get('stop')) return;
    //   this._options.logHandler(`${data.from} -> ${data.to}`, LogType.HISTORY);
    // }
    GlobalHandlers.prototype._consoleHandler = function (data) {
        if (Config.get('stop'))
            return;
        this._options.logHandler({
            content: data.args,
            level: data.level
        }, LogType.CONSOLE);
    };
    GlobalHandlers.prototype._nativeapiHandler = function (data) {
        if (Config.get('stop'))
            return;
        this._options.logHandler(data, LogType.NATIVEAPI);
    };
    GlobalHandlers.prototype._unhandledrejectionHandler = function (e) {
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) {
                error = e.reason;
            }
            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
            // https://github.com/getsentry/sentry-javascript/issues/2380
            else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_oO) {
            // no-empty
        }
        this._options.errorHandler(error, LogType.UNHANDLEDREJECTION);
    };
    GlobalHandlers.prototype._errorHandler = function (data) {
        this._options.errorHandler(JSON.stringify(data), LogType.ERROR);
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());
export { GlobalHandlers };
